const getResultUrl = resultHash =>
  `${window.location.href.replace(window.location.hash, '')}?hide-sidebar=true#search:${resultHash}`

export { getResultUrl }
